<template>
  <div class="toolDescribe">
    <img class="describe-icon" src="https://i4-ws.resource.ccplay.cn/media/packages/2015/08/28/1427-09-685/0.png-icon.xhuge">
    <div class="describe-center">
      <div class="describe-center-title">少女前线(测试服)</div>
      <div class="describe-center-brief">一句话简介这一句话简介一句话最长到到到这</div>
    </div>
    <div class="describe-score">
      <span>打开</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolDescribe'
}
</script>

<style scoped lang="scss">
.toolDescribe{
  position: relative;
  padding: 17px 0;
  padding-left: 8px;
  display: flex;
  align-items: center;
  background: #202632;
  border-radius: 6px;
  .describe-icon{
    width: 79px;
    height: 79px;
    background: #959595;
    border-radius: 15px;
  }
  .describe-center{
    margin-left: 14px;
    .describe-center-title{
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #F5F5F5;
      margin-bottom: 14px;
    }
    .describe-center-brief{
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #68829E;
      width: 160px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
  .describe-score{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 28px;
    background: rgba(41, 146, 255, 0);
    border: 1px solid #2992FF;
    border-radius: 14px;

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #2992FF;
    position: absolute;
    right: 8px;
  }

}
</style>
